const resource = accountId => `/api/v1/accounts/${accountId}/exception_cases`;

export default {
  get(accountId, params) {
    return window.axios.get(resource(accountId), { params });
  },
  update(accountId, id, data) {
    return window.axios.patch(`${resource(accountId)}/${id}`, data);
  },
  operate(accountId, conversationId, messageId, kind) {
    return window.axios.post(
      `/api/v1/accounts/${accountId}/conversations/${conversationId}/messages/${messageId}/bcw_operation`,
      { kind, request_key: crypto.randomUUID() }
    );
  },
};
